import type { CSSProperties } from 'react';
import { cn } from '@tark/shared/lib';
import tarkLogo from '../assets/branding/tark-logo.png';

type BrandMarkSize = 'sm' | 'md' | 'lg';
type BrandMarkTone = 'brand' | 'theme';

interface BrandMarkProps {
  size?: BrandMarkSize;
  tone?: BrandMarkTone;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  subtitle?: string;
  showTrademark?: boolean;
  showText?: boolean;
}

const sizeMap: Record<BrandMarkSize, string> = {
  sm: 'h-11 w-11',
  md: 'h-12 w-12',
  lg: 'h-14 w-14',
};

export default function BrandMark({
  size = 'md',
  tone = 'brand',
  className,
  titleClassName,
  subtitleClassName,
  subtitle,
  showTrademark = false,
  showText = true,
}: BrandMarkProps) {
  const themedLogoStyle: CSSProperties = {
    background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%)',
    maskImage: `url(${tarkLogo})`,
    maskPosition: 'center',
    maskRepeat: 'no-repeat',
    maskSize: 'contain',
    WebkitMaskImage: `url(${tarkLogo})`,
    WebkitMaskPosition: 'center',
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskSize: 'contain',
  };

  return (
    <div className={cn('flex items-center gap-3 text-text', className)}>
      {tone === 'theme' ? (
        <span
          role="img"
          aria-label="TARK logo"
          className={cn('block shrink-0 self-center', sizeMap[size])}
          style={themedLogoStyle}
        />
      ) : (
        <img src={tarkLogo} alt="TARK logo" className={cn('block shrink-0 self-center object-contain', sizeMap[size])} />
      )}
      {showText ? (
        <div className="min-w-0 flex flex-col justify-center">
          <div
            className={cn(
              'inline-flex items-start leading-none text-xl font-black tracking-tight',
              tone === 'theme' ? 'text-primary' : 'text-text',
              titleClassName
            )}
          >
            TARK
            {showTrademark ? (
              <span className="relative -top-[0.38em] ml-0.5 text-[0.42em] font-normal tracking-normal opacity-45">TM</span>
            ) : null}
          </div>
          {subtitle ? (
            <div className={cn('mt-1 text-xs uppercase tracking-[0.22em] text-text-subtle', subtitleClassName)}>
              {subtitle}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
